import { useRef } from 'react'
import LogoBlack from '../../../assets/images/logo-black.png'
import './index.scss'

const Logo = () => {
  const bgRef = useRef()
  //const outlineLogoRef = useRef()
  const solidLogoRef = useRef()

  return (
    <div className="logo-container" ref={bgRef}>
      <img
        className="solid-logo"
        ref={solidLogoRef}
        src={LogoBlack}
        alt="JavaScript,  Developer"
      />
    </div>
  )
}

export default Logo
